import { memo, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";
import { debounce } from "utils/helpers";

const RootScrollToTop = () => {
	const { t } = useTranslation();

	// ref hook
	const scrollToTopButtonRef = useRef(null);

	// effect hook
	useEffect(() => {
		let lastWindowWidth = window.innerWidth;
		const scrollToTopButtonRefCurrent = scrollToTopButtonRef?.current;
		const scrollToTopButtonVisibilityIndicator = () => {
			let doc = document.documentElement;
			let wScroll = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
			if (wScroll <= 0) return scrollToTopButtonRef?.current?.classList.remove("root-scroll-to-top-scrolling");
			scrollToTopButtonRef?.current?.classList.add("root-scroll-to-top-scrolling");
		};
		const scrollToTopClickHandler = () => window.scrollTo({ top: 0, behavior: "smooth" });

		scrollToTopButtonVisibilityIndicator();

		scrollToTopButtonRefCurrent?.addEventListener("click", scrollToTopClickHandler);
		window.addEventListener(
			"scroll",
			debounce(() => scrollToTopButtonVisibilityIndicator(), 100)
		);
		window.addEventListener(
			"resize",
			debounce(() => {
				if (window.width !== lastWindowWidth) {
					scrollToTopButtonVisibilityIndicator();
					lastWindowWidth = window.innerWidth;
				}
			}, 100)
		);
		window.addEventListener(
			"orientationchange",
			debounce(() => {
				if (window.width !== lastWindowWidth) {
					scrollToTopButtonVisibilityIndicator();
					lastWindowWidth = window.innerWidth;
				}
			}, 100)
		);

		return () => {
			scrollToTopButtonRefCurrent?.removeEventListener("click", scrollToTopClickHandler);
			window.removeEventListener("scroll", scrollToTopButtonVisibilityIndicator);
			window.removeEventListener("resize", scrollToTopButtonVisibilityIndicator);
			window.removeEventListener("orientationchange", scrollToTopButtonVisibilityIndicator);
		};
	}, []);

	return (
		<div className="root-scroll-to-top d-print-none" ref={scrollToTopButtonRef}>
			<button
				type="button"
				className="btn btn-link btn-sm bg-white text-decoration-none shadow rounded-3 p-2"
				title={t("actions.back_to_top")}
				aria-label={t("actions.back_to_top")}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="2rem"
					height="2rem"
					fill="currentColor"
					viewBox="0 0 16 16"
					aria-hidden="true">
					<path
						fillRule="evenodd"
						d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
					/>
				</svg>
			</button>
		</div>
	);
};

export default memo(RootScrollToTop);
